module.exports = __webpack_public_path__ + "static/media/search.99724c59.svg";